(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-no-search-results/assets/javascripts/casino-no-search-results.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-no-search-results/assets/javascripts/casino-no-search-results.js');

'use strict';

const {
  Card,
  CardBody
} = svs.ui.ReactCard;
const {
  useSearchResults
} = svs.components.casino_react.casinoStore.hooks;
const CasinoNoSearchResults = () => {
  const {
    latestSearchQuery
  } = useSearchResults();
  const errorText = latestSearchQuery ? "Din s\xF6kning p\xE5 '".concat(latestSearchQuery, "' gav inga tr\xE4ffar") : 'Inga träffar';
  return React.createElement(Card, {
    className: "casino-no-search-result"
  }, React.createElement(CardBody, {
    center: true,
    className: "casino-no-search-result__body"
  }, React.createElement("h3", {
    className: "casino-no-search-result__body-heading"
  }, "Oj d\xE5!"), React.createElement("p", {
    className: "casino-no-search-result__body-text"
  }, errorText)));
};
setGlobal('svs.components.casino_react.CasinoNoSearchResults', CasinoNoSearchResults);

 })(window);